namespace Solovis.UI {

    /**
     * DynamicLoadPlaceholderControl will create the control only after the control
     * has initialized (which includes loading all required modules).
     */
    export class DynamicLoadPlaceholderControl extends Solovis.UI.BaseControl {

        public controlTypeName: string;
        public newControlOptions: any;

        constructor(options) {
            super(options);

            this.controlTypeName = options.controlTypeName;
            this.newControlOptions = options.newControlOptions;
        }

        public doInitAsync = function () {
            var self = this;

            var controlTypeName = this.controlTypeName;
            var newControlOptions = this.newControlOptions;

            var doInitializeControl = function () {
                // We only proceed to loading the class if state is beforeInit. Otherwise,
                // we know that this control has already been replaced with something else.
                if (self.state == Solovis.UI.BaseControl.ControlState.beforeInit) {
                    var controlTypeObject = Solovis.resolveObject(controlTypeName, window);

                    if (controlTypeObject) {
                        var instance = new controlTypeObject(newControlOptions);
                        self.controlHost.setCurrentControl(instance);
                    }
                    else {
                        self.errorMessage = "Unable to find control type: " + controlTypeName;
                        self.notifyInitComplete();
                    }
                }
            };

            var controlTypeObject = Solovis.resolveObject(controlTypeName, window);
            if (controlTypeObject) {
                doInitializeControl();
            }
            else {
                Solovis.ModuleLoader.loadModuleForClass(controlTypeName, function () {
                    doInitializeControl();
                });
            }
        }

        public doRender = function () {
            this.container.text(this.errorMessage);
        }
    }    

}